import { getData, postFormData, deleteData } from "./index";
export const earning = async (payload) => {
  return getData("admin/earning", payload).then((data) => {
    return data;
  });
};
export const earningTeacher = async (payload) => {
  return getData("admin/earningTeacher", payload).then((data) => {
    return data;
  });
};
export const earningDetails = async (payload) => {
  return getData("admin/earningDetails", payload).then((data) => {
    return data;
  });
};
export const fetchSetting = async (payload) => {
  return getData("admin/fetchSettings", payload).then((data) => {
    return data;
  });
};
export const studentWiseEarningDetails = async (payload) => {
  return getData("admin/studentWiseEarningDetails", payload).then((data) => {
    return data;
  });
};
export const cancelEarningDetails = async (payload) => {
  return getData("admin/cancelEarningDetails", payload).then((data) => {
    return data;
  });
};
export const saveFeeSettings = async (payload) => {
  return postFormData("admin/saveFeeSettings", payload).then((data) => {
    return data;
  });
};
export const getMembershipPurchasesApi = async (payload) => {
  return getData("admin/getMembershipPurchases", payload).then((data) => {
    return data;
  });
};
export const getEventPurchasesApi = async (payload) => {
  return getData("admin/getEventPurchases", payload).then((data) => {
    return data;
  });
};
export const getClassPurchasesApi = async (payload) => {
  return getData("admin/getClassPurchases", payload).then((data) => {
    return data;
  });
};
export const getExpenseDetailsApi = async (payload) => {
  return getData("admin/getExpenseDetails", payload).then((data) => {
    return data;
  });
};
export const saveFinanceReportToArchive = async (payload) => {
  return postFormData("admin/saveFinanceReportToArchive", payload).then((data) => {
    return data;
  });
};

export const getArchivedFinanceReports = async (company_id) => {
  return getData(`admin/getArchivedFinanceReports?company_id=${company_id}`).then((data) => {
    return data;
  });
};

export const deleteArchivedFinanceReport = async (reportId) => {
  return deleteData(`admin/deleteArchivedFinanceReport`, { id: reportId }).then((data) => {
    return data;
  });
};

